import { searchCarApi, handleFiftyMileSearchClick } from '../../services/api/search.service';
import { moveNext } from './workflow';
import { carSearchType } from '../../constants/Enums';
import {
  getFilterByDetails,
  getFilterBySearchType,
  getCarsFromCarResult,
} from '../../utils/car.utils';
import {
  selectActiveComponentIndex,
  selectTripResults,
  selectSearchInput,
} from '../selectors/search.selector';
import { selectCarSearchResults, selectActiveCarComponent } from '../selectors/car.selector';
import { selectCheckedRebookPassengers } from '../selectors/mytrips.selector';
import to from '../../utils/to';
import i18n from '../../i18n';
import { openAlert } from './alert';
import { logException } from '../../utils/logger.utils';
import * as RootNavigation from '../../utils/navigationRef';
import { selectAccessToken, selectCompanyConfig } from '../selectors/auth.selector';
import { evaluateSearch, searchStatus } from '../../utils/search.utils';
import { Screens } from '../../constants/ScreenNames';
import { isNullOrEmpty } from '../../utils/common.utils';

export const SET_CAR_RESULTS = 'SET_CAR_RESULTS';
export const SELECT_CAR = 'SELECT_CAR';
export const ORDER_CAR_BY = 'ORDER_CAR_BY';
export const ORDER_CAR_BY_REVERSE = 'ORDER_CAR_BY_REVERSE';
export const FILTER_CAR_BY_TYPE = 'FILTER_CAR_BY_TYPE';
export const FILTER_CAR_BY_SEARCH_TYPE = 'FILTER_CAR_BY_SEARCH_TYPE';
export const FILTER_CAR_BY_DETAILS = 'FILTER_CAR_BY_DETAILS';
export const CLEAR_CAR = 'CLEAR_CAR';

export const selectCar = (selectedCar) => {
  return async (dispatch, getState) => {
    const displayIndex = selectActiveComponentIndex(getState());
    const carSearchResults = selectCarSearchResults(getState());
    const lowestFare = Math.min.apply(
      Math,
      carSearchResults?.CarTypeList?.map(function (o) {
        return o.LowestPrice;
      })
    );
    dispatch({
      type: SELECT_CAR,
      selectedCar,
      lowestFare,
      displayIndex,
    });
    dispatch(moveNext());
  };
};

export const handleFiftyMileCarSearch = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const accessToken = selectAccessToken(state);
    const displayIndex = selectActiveComponentIndex(state);
    const results = selectTripResults(state);
    let car50MilesSearchResults = [];

    const travelRequestId = results.TravelRequestId;
    const requestedComponents = results.RequestedComponents;
    const searchInput = selectSearchInput(state);
    const rebookPassengers = selectCheckedRebookPassengers(state);
    const getCompanyCulture = selectCompanyConfig(state);

    const carRequestedComponent = requestedComponents.find((x) => x.DisplayIndex === displayIndex);
    const carComponentRequestId = carRequestedComponent && carRequestedComponent.ComponentRequestId;
    try {
      let [error, car50SearchResults] = await to(
        handleFiftyMileSearchClick(
          accessToken,
          travelRequestId,
          carComponentRequestId,
          searchInput,
          rebookPassengers,
          getCompanyCulture
        )
      );

      if (!isNullOrEmpty(car50SearchResults)) {
        if (JSON.parse(car50SearchResults).Message == 'success') {
          const [err, carSearchResults] = await to(
            searchCarApi(accessToken, travelRequestId, carComponentRequestId)
          );
          car50MilesSearchResults = carSearchResults;
          error = err;
        }
      }
      if (error) {
        logException(error, { metaData: { travelRequestId, carComponentRequestId } });
        dispatch(
          openAlert({
            title: i18n.t('Car50MilesSearchFailureMessage'),
            confirmText: i18n.t('GoBack'),
            onConfirmPressed: () => RootNavigation.goBack(),
          })
        );
        return;
      }

      dispatch(setCarSearchResultAction(car50MilesSearchResults, displayIndex, results, false));
    } catch (error) {
      dispatch(
        openAlert({
          title: i18n.t('Car50MilesSearchFailureMessage'),
          confirmText: i18n.t('GoBack'),
          onConfirmPressed: () => RootNavigation.goBack(),
        })
      );
      logException(error, { metaData: { travelRequestId, carComponentRequestId } });
      return;
    }
  };
};

export const carSearch = (attempts = 0, isFirstAttempt = true, temporalData) => {
  return async (dispatch, getState) => {
    const route = RootNavigation.getCurrentRoute();
    if (Screens.Car !== route?.name) {
      return;
    }
    const carSearchResultsSelector = selectCarSearchResults(getState());
    const accessToken = selectAccessToken(getState());
    const displayIndex = selectActiveComponentIndex(getState());
    const results = selectTripResults(getState());
    const travelRequestId = results.TravelRequestId;
    const requestedComponents = results.RequestedComponents;
    const carRequestedComponent = requestedComponents.find((x) => x.DisplayIndex === displayIndex);
    const carComponentRequestId = carRequestedComponent && carRequestedComponent.ComponentRequestId;
    try {
      let [err, carSearchResults] = await to(
        searchCarApi(accessToken, travelRequestId, carComponentRequestId)
      );
      if (!isNullOrEmpty(carSearchResults) && carSearchResults.Cars.length === 0) {
        dispatch(
          openAlert({
            title: i18n.t('CarSearchFailureMessage'),
            confirmText: i18n.t('GoBack'),
            onConfirmPressed: () => RootNavigation.goBack(),
          })
        );
        return;
      }

      if (err) {
        logException(err, { metaData: { travelRequestId, carComponentRequestId } });
        if (attempts === 0) {
          dispatch(
            openAlert({
              title: i18n.t('CarSearchFailureMessage'),
              confirmText: i18n.t('GoBack'),
              onConfirmPressed: () => RootNavigation.goBack(),
            })
          );
          return;
        }
      }

      const evaluation = evaluateSearch({
        isFirstAttempt,
        attempts,
        newResults: temporalData?.Cars,
        initialResults: carSearchResultsSelector?.Cars,
        currentResults: carSearchResults?.Cars,
      });

      switch (evaluation) {
        case searchStatus.INCOMPLETE:
          dispatch(carSearch(attempts - 1, false, carSearchResults));
          return;
        case searchStatus.COMPLETE:
          carSearchResults = temporalData;
          break;
        case searchStatus.CANCELED:
          return;
        case searchStatus.PARTIAL:
        default:
          break;
      }

      dispatch(setCarSearchResultAction(carSearchResults, displayIndex, results, false));
      // if (attempts > 0 && evaluation !== searchStatus.COMPLETE) {
      //   dispatch(carSearch(attempts - 1, false, carSearchResults));
      // }
    } catch (error) {
      dispatch(
        openAlert({
          title: i18n.t('CarSearchFailureMessage'),
          confirmText: i18n.t('GoBack'),
          onConfirmPressed: () => RootNavigation.goBack(),
        })
      );
      logException(error, { metaData: { travelRequestId, carComponentRequestId } });
      return;
    }
  };
};

const setCarSearchResultAction = (carSearchResults, displayIndex, results) => {
  const Cars = getCarsFromCarResult(carSearchResults);

  const hasCitySearchResults = carSearchResults.CityCarMatrix
    ? carSearchResults.CityCarMatrix.length > 0
    : false;
  const hasAirportSearchResults = carSearchResults.AirportCarMatrix
    ? carSearchResults.AirportCarMatrix.length > 0
    : false;

  const { IsCityCarSearch, IsAirportCarSearch } = results;

  let filterBySearchType =
    IsAirportCarSearch && hasAirportSearchResults
      ? carSearchType.AIRPORT
      : IsCityCarSearch && hasCitySearchResults
      ? carSearchType.CITY
      : null;

  if (filterBySearchType === null) {
    filterBySearchType = hasAirportSearchResults
      ? carSearchType.AIRPORT
      : hasCitySearchResults
      ? carSearchType.CITY
      : null;
  }

  const filterByDetails = getFilterByDetails(carSearchResults, filterBySearchType);
  const filterListBySearchType = getFilterBySearchType(carSearchResults);
  return async (dispatch) => {
    dispatch({
      type: SET_CAR_RESULTS,
      searchResults: {
        ...carSearchResults,
        Cars,
      },
      filterByDetails,
      filterListBySearchType,
      filterBySearchType,
      carListFiltered: Cars,
      displayIndex,
    });
  };
};

export const orderBy = (key) => {
  return async (dispatch, getState) => {
    const displayIndex = selectActiveComponentIndex(getState());
    const { orderBy, reverse } = selectActiveCarComponent(getState());

    if (orderBy === key) {
      dispatch({
        type: ORDER_CAR_BY_REVERSE,
        reverse: !reverse,
        displayIndex,
      });
    } else {
      dispatch({
        type: ORDER_CAR_BY,
        reverse: false,
        orderBy: key,
        displayIndex,
      });
    }
  };
};

export const filterByType = (key) => {
  return async (dispatch, getState) => {
    const displayIndex = selectActiveComponentIndex(getState());
    dispatch({
      type: FILTER_CAR_BY_TYPE,
      filterByType: key,
      displayIndex,
    });
  };
};

export const clearSelectedCarCache = (searchInput, selectedCar) => {
  return async (dispatch) => {
    if (selectedCar && selectedCar.length > 0) {
      dispatch({ type: CLEAR_CAR, selectedCar });
    }
  };
};
export const filterBySearchType = (key) => {
  return async (dispatch, getState) => {
    const displayIndex = selectActiveComponentIndex(getState());
    const searchResults = selectCarSearchResults(getState());
    const filterByDetails = getFilterByDetails(searchResults, key);

    dispatch({
      type: FILTER_CAR_BY_SEARCH_TYPE,
      filterByDetails,
      filterBySearchType: key,
      displayIndex,
    });
  };
};

export const filterByDetails = (obj) => {
  return async (dispatch, getState) => {
    const displayIndex = selectActiveComponentIndex(getState());
    dispatch({
      type: FILTER_CAR_BY_DETAILS,
      filterByDetails: obj,
      displayIndex,
    });
  };
};
